import React from 'react';

export default function About() {
  return (
    <div style={{ maxWidth: 700, margin: '40px auto', padding: 32 }}>
      <h1 style={{ fontSize: 32, fontWeight: 700, marginBottom: 16 }}>About InnBotics</h1>
      <p style={{ fontSize: 18, color: '#444', marginBottom: 24 }}>
        InnBotics is a next-generation hotel discovery and booking platform, blending AI-powered recommendations, smart room technology, and seamless guest experiences. Our mission is to make travel personal, easy, and inspiring for everyone.
      </p>
      <ul style={{ fontSize: 17, color: '#2563eb', marginBottom: 24 }}>
        <li>Best prices, always</li>
        <li>Secure, instant booking</li>
        <li>Smart rooms & trusted hotels</li>
        <li>Guest-first experience</li>
      </ul>
      <p style={{ fontSize: 16, color: '#666' }}>
        Whether you're planning a family vacation, a business trip, or a weekend escape, InnBotics helps you find the perfect stay—no login required to browse!
      </p>
    </div>
  );
}
